<template>
    <v-col cols="12" class="primary">
        <v-row
            align="center"
            justify="center"
        >
            <v-col cols=9 class='text-left'>
                <a href="/">
                    <v-img :src="`${require('@/assets/logo-blanco-innofarm.png')}`" width="150px" />
                </a>
            </v-col>
            <v-col cols=3 class='text-right'>
                <v-btn
                    class="white--text py-5  icon-menu"
                    elevation="1"
                    small
                    @click="drawer = !drawer"
                >
                    <v-icon color="white" v-if="drawer"> mdi-close </v-icon>
                    <v-icon color="white" v-else> mdi-menu </v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-navigation-drawer
            app
            id="core-navigation-drawer"
            v-model="drawer"
            color='primary'
            width="100%"
            style="top: 104px;"
            overlay-opacity='0'
        >
            <v-col class="text-left white--text pt-8 px-6">
                <MiniShippingCarComponent class='shoppingBag' @closeDrawer=closeDrawer />
                <div class=''>
                    <a href="/" class="white--text link-menu ">Inicio</a>
                    <br />
                    <a href="/perfil-cliente" class="white--text link-menu ">Perfil del cliente</a>
                    <br />
                    <a href="/medicamentos-especialidad" class="white--text link-menu ">Medicina de especialidad</a>
                    <br />
                    <a href="/nosotros" class="white--text link-menu ">Nosotros</a>
                    <br />
                    <a href="/empresas_pymes" class="white--text link-menu ">Corporativo</a>
                    <br />
                    <a href="/sedes" class="white--text link-menu ">Sedes</a>
                    <br />
                    <a href="/contactos" class="white--text link-menu ">Contacto</a>
                    <hr  style='border:1px solid #eaeaea6b' class='my-2' />
                    <a href="/covid19" class="white--text link-menu ">Covid 19</a>
                    <br />
                    <a href="/trabaja-con-nosotros" class="white--text link-menu ">Trabaje con nosotros</a>
                    <hr  style='border:1px solid #eaeaea6b' class='my-2' />
                </div>
                <v-col cols="12" class='mt-2 pl-0'>
                        <v-row class='ml-md-3'>
                            <v-col cols="12" >
                                <div class='text-md-left mb-5'><b>TELÉFONOS DE CONTACTO</b></div>
                                <div class='text-md-left font-title'>
                                    <h2>
                                        <v-btn 
                                            icon 
                                            elevation="2" 
                                            style="background:white"
                                        >
                                            <v-icon color="#62c091">mdi-24px  mdi-phone</v-icon>
                                        </v-btn>
                                        <a href='telf:02510070' class='text-decoration-none white--text'>
                                            (02) 5100700
                                        </a>
                                    </h2>
                                </div>
                                <div class='text-md-left mt-4 font-title'>
                                    <h2>
                                        <v-btn 
                                            icon 
                                            elevation="2" 
                                            style="background:white"
                                        >
                                            <v-icon color="#62c091">mdi-24px  mdi-whatsapp</v-icon>
                                        </v-btn>
                                        <a class='text-decoration-none white--text' target='_blank' href='https://api.whatsapp.com/send?phone=+593991342224'>
                                            099 134 2224
                                        </a>
                                    </h2>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
            </v-col>
            <!-- <v-col class="text-left white--text link-menu pt-8 px-6">
                <h3>SERVICIOS</h3> 
                <div class='mt-6'>
                    <a href="/nosotros" class="white--text link-menu ">Medicina de especialidad</a>
                    <br />
                    <a href="/sedes" class="white--text link-menu ">Análisis de laboratorio</a>
                    <br />
                    <a href="/nosotros" class="white--text link-menu ">Estudios médicos</a>
                    <br />
                    <a href="/nosotros" class="white--text link-menu ">Enfermería</a>
                    <br />
                    <a href="/nosotros" class="white--text link-menu ">Aplicaciones</a>
                    <br />
                    <a href="/nosotros" class="white--text link-menu ">Empresas y Pymes</a>
                </div>
            </v-col> -->
        </v-navigation-drawer>
   </v-col>
</template>

<script>
import MiniShippingCarComponent from '../partials/MiniShippingCarComponent'
export default {
    name:'MenuMovilComponent',
    components:{
        MiniShippingCarComponent
    },
    data:()=>({
        drawer:false,
        location :'',
    }),
    methods:{
        closeDrawer(){
            this.drawer=false
        }
    },
    beforeUpdate(){
        this.location = location.pathname
    },
    created(){
        this.location = location.pathname
    }
}
</script>

<style>
    .icon-menu{
        border-color: white!important;
        border: 2px solid!important;
        border-radius: 10px!important;
        background: transparent!important;
    }

    .shoppingBag{
        float: right;
        position: absolute;
        top: 11px;
        right: 33px;
    }

    .link-menu{
        text-decoration: none;
        font-size:17px
    }
    
</style>